import React from 'react';

const ScrollButtons = () => {
    const ScrollBlockRight = () => {
        document.getElementById('product-block').scrollBy({left: 1000, behavior: 'smooth'})
    }

    const ScrollBlockLeft = () => {
        document.getElementById('product-block').scrollBy({left: -1000, behavior: 'smooth'})
    }

    return (
        <div className="product-block-scroll">
            <button className="slideLeft" id="slideLeft" type="button" onClick={() => ScrollBlockLeft()}>&#60;</button>
            <button className="slideRight" id="slideRight" type="button" onClick={() => ScrollBlockRight()}>&#62;</button>
        </div>
    );
};

export default ScrollButtons;

